module.exports = __webpack_public_path__ + "static/media/partners_w_circle.705b398d.svg";